module.exports = __webpack_public_path__ + "img/196.problem_urinals.9ff50ebe.svg";